<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" v-model="pointReward" @[reloadEvent(Component)]="reload" />
  </router-view>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { useFetchQuery } from '@hooks/fetch';
import { syncPageBusy } from '@utils/busy/injects';
import { computed } from 'vue';
import { syncHeader } from '@components/structure/navigation/injects';
import { useI18n } from 'vue-i18n';
import type { PointReward } from '@/entities/Entities';

const route = useRoute();
const { t } = useI18n();

const {
  data: pointReward,
  loading,
  refetch,
} = useFetchQuery<PointReward>(
  `/point_rewards/${route.params.pointRewardId}`,
);

syncPageBusy(loading);

const title = computed(() => pointReward.value?.name ?? '');

const longTitle = computed(() => {
  if (!pointReward.value) return '';
  return `${pointReward.value.name} (${pointReward.value.cost} ${t('navigation.loyalty.points')})`;
});

const reloadEvent = (component: any) => (component.type.emits?.includes('reload') ? 'reload' : '');

syncHeader(pointReward, () => ({
  extraBreadcrumbs: [
    computed(() => ({
      label: title.value,
      link: {
        name: 'point-reward-details',
        params: { pointRewardId: pointReward.value?.id ?? '-' },
      },
    })),
  ],
  title: computed(() => ({
    text: longTitle.value,
    link: { name: 'point-rewards' },
  })),
}));

const reload = async () => {
  await refetch();
};
</script>

<style lang="scss" scoped></style>
